import { useCallback } from 'react'
import type { DataNode } from '../types'
import { useContentItemViewNode } from './useContentItemViewNodeService'

/**
 * Custom hook to handle actions related to Paragraph content items
 * @returns Actions related to Paragraph content items
 */
export const useParagraphActions = () => {
    const {
        contentItemViewNodes,
        findContentItemNode,
        insertNodeAfterSibling,
        setAddingNode,
        createContentItemViewNode,
    } = useContentItemViewNode()

    /**
     * Adds a Paragraph content item after a sibling content item
     * @param sibling Sibling content item to insert this node after
     */
    const addParagraphAfterSibling = useCallback(
        (sibling: DataNode) => {
            const siblingNode = findContentItemNode(sibling.key)

            if (!siblingNode) return

            // Save new node and reorder siblings to Local State
            const paragraphNode = createContentItemViewNode('', siblingNode)
            insertNodeAfterSibling(paragraphNode, siblingNode.id)
            // Set currently being added node to focus
            setAddingNode(paragraphNode)
        },
        [
            contentItemViewNodes,
            findContentItemNode,
            createContentItemViewNode,
            insertNodeAfterSibling,
        ]
    )

    return { addParagraphAfterSibling }
}
